'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useCallback, useState } from 'react';

interface UseOrganisationSwitchConfirmationOptions<T> {
  switchToItem: (item: T) => void;
}

interface UseOrganisationSwitchConfirmationResult<T> {
  pendingItem: T | null;
  requestSwitch: (item: T) => void;
  confirmSwitch: () => void;
  isDialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
}

export function useOrganisationSwitchConfirmation<T>(
  options: UseOrganisationSwitchConfirmationOptions<T>
): UseOrganisationSwitchConfirmationResult<T> {
  const { switchToItem } = options;
  const [pendingItem, setPendingItem] = useState<T | null>(null);

  const requestSwitch = useCallback((item: T) => {
    setPendingItem(item);
  }, []);

  const confirmSwitch = useCallback(() => {
    if (pendingItem == null) return;
    switchToItem(pendingItem);
    setPendingItem(null);
  }, [pendingItem, switchToItem]);

  const setDialogOpen = useCallback((open: boolean) => {
    if (!open) setPendingItem(null);
  }, []);

  return {
    pendingItem,
    requestSwitch,
    confirmSwitch,
    isDialogOpen: pendingItem != null,
    setDialogOpen,
  };
}
